import { render, staticRenderFns } from "./ServiceHintsModal.vue?vue&type=template&id=5424720b&scoped=true"
import script from "./ServiceHintsModal.vue?vue&type=script&lang=js"
export * from "./ServiceHintsModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceHintsModal.vue?vue&type=style&index=0&id=5424720b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424720b",
  null
  
)

export default component.exports